import { Component, EventEmitter, computed, input, Output, forwardRef, signal } from '@angular/core';
import { DisplayMode, SelectComponent, SelectOptionComponent } from '../select.component';
import { GearSizeType } from "../../../models/enums";
import { FormsModule, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseComponent } from '../../base.component';
@Component({
  selector: 'app-select-gear-size',
  imports: [FormsModule, SelectComponent, SelectOptionComponent],
  templateUrl: './select-gear-size.component.html',
  styleUrl: './select-gear-size.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectGearSizeComponent),
      multi: true
    }
  ],
  host: {
    '[class.inline]': 'inline()'
  }
})
export class SelectGearSizeComponent extends BaseComponent implements ControlValueAccessor {
  disabled = input<boolean>(false);
  allowedSizes = input<GearSizeType[] | undefined>(undefined);
  inline = input<boolean>(false);
  displayMode = computed(() => this.settings.hideIconsInDropdowns() ? 'textOnly' : 'prefixAndText');

  @Output('selectedValueChange') selectedValueChangeEmitter = new EventEmitter<GearSizeType>();

  GearSizeType = GearSizeType;

  // Internal model for ngModel binding
  internalModel = signal<GearSizeType>(GearSizeType.All);

  private onChange = (value: GearSizeType) => {};
  private onTouched = () => {};

  // ControlValueAccessor implementation
  writeValue(value: GearSizeType): void {
    this.internalModel.set(value);
  }

  registerOnChange(fn: (value: GearSizeType) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    // Input signals are read-only, so we can't set them directly
    // The disabled state is handled by the parent component
  }

  onModelChange(value: string | undefined) {
    if (value !== undefined) {
      const gearSizeValue = value as GearSizeType;
      this.onChange(gearSizeValue);
      this.onTouched();
      this.selectedValueChangeEmitter.emit(gearSizeValue);
    }
  }
}
